export function resolveStageId(entity) {
  if (!entity) return null;
  if (entity.stage_id != null && entity.stage_id !== '') {
    const id = Number(entity.stage_id);
    return Number.isNaN(id) ? null : id;
  }
  if (
    entity.stage &&
    typeof entity.stage === 'object' &&
    entity.stage.id != null
  ) {
    const id = Number(entity.stage.id);
    return Number.isNaN(id) ? null : id;
  }
  if (
    entity.stage != null &&
    entity.stage !== '' &&
    typeof entity.stage !== 'object'
  ) {
    const id = Number(entity.stage);
    return Number.isNaN(id) ? null : id;
  }
  return null;
}

export function withStageId(entity = {}) {
  const next = { ...entity };
  next.stage_id = resolveStageId(entity);
  delete next.stage;
  return next;
}
